import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD_Oj1XtG0YUeGxyaTcqy4dFfLn8cShhto",
  authDomain: "zpotter-f1d26.firebaseapp.com",
  projectId: "zpotter-f1d26",
  storageBucket: "zpotter-f1d26.firebasestorage.app",
  messagingSenderId: "881776013915",
  appId: "1:881776013915:web:38a3725a38ba20ab3c057e",
  measurementId: "G-6XXVZ1WWPJ",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
  const permision = await Notification.requestPermission();
  console.log(permision);
  if (permision === "granted") {
    const fcmToken = await getToken(messaging, {
      vapidKey:
        "BCjj2lc5iNpsjn9HWmOGYytEBJdsyLY4sQMUQbyh2A-q6o87TluGIW687XltSISCawX3cmG_pb3kbz4ZPb0U5N4",
    });

    console.log("fcmToken");
    console.log(fcmToken);
  }
};
